import { Injectable } from '@angular/core';
import { EncryptionService } from '../encryption/encryption.service';
import { ReusableClasses } from './reusableclassesAndFunctions/reusable-classes';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from './reusableclassesAndFunctions/constants';
import { ResetPasswordReqVM } from 'src/app/viewModels/resetPassword/reset-password-req-vm';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiEndPointsUser } from 'src/app/applicationModules/users/common/apiUrls/api-end-points';
import * as jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

 public listRefreshPeople = new BehaviorSubject<boolean>(false);
public loadPeopleList = this.listRefreshPeople.asObservable();

public setCurrentUser = new BehaviorSubject<any>(undefined);
public getCurrentuser = this.setCurrentUser.asObservable();


  currentUser: any;
  EditData: any;
  closePanel: boolean = false;
  fieldType: any;
  subfolderId: any;
  SubfolderModel={
    fieldType: 0,
    subfolderId: 0
  };
  fieldEditModel={
    fieldData: {},
    fieldFolderType: 0
  }
  private baseUrl:any;
  

  constructor(private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private _http: HttpClient, private apiAddress: ApiEndPointsUser, public env: EnvService,
    private constant: Constants, private router: Router) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrl = this.constant.ManageUserPortNumber;
  else
      this.baseUrl = this.env.apiUrl+this.constant.ManageUserPortNumber;
     
     }

  // private baseUrl = this.env.apiUrl;
  //private baseUrl = this.env.apiUrl + this.constant.ManageUserPortNumber;
  //private baseUrl = this.constant.ManageUserPortNumber;
  private refreshTokenBaseUrl = this.env.apiUrl;

  //Summary
  //Setting user details while they login to the system....
  //Also we are here setting the token in localstorage after performing encryption.
  setLoggedInUserDetails(userData, decryptedToken, permissions, menuModules,databaseID, organizationID) {
    if (userData != undefined) {
      this.currentUser = userData;
      this.setCurrentUser.next(userData);
      //(this.currentUser);
      let encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, decryptedToken);
      if (permissions != undefined && permissions != null && permissions != '') 
      {
        sessionStorage.setItem('permissions', JSON.stringify(permissions));                
      } 
      sessionStorage.setItem('menuModules', JSON.stringify(menuModules)); 
      sessionStorage.setItem('databaseId', databaseID);
      sessionStorage.setItem('organizationID', organizationID);
      sessionStorage.setItem('userToken', encryptedToken);
      sessionStorage.setItem('isRefresh', JSON.stringify(false));
    }
  }

  setLoggedInUserDetailsSession(userData, decryptedToken, permissions, databaseID, organizationID) {
    if (userData != undefined) {
      this.currentUser = userData;
      this.setCurrentUser.next(userData);
      //(this.currentUser);
      let encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, decryptedToken);
      // if (permissions != undefined && permissions != null && permissions != '') 
      // {
      //   sessionStorage.setItem('permissions', permissions);   
      //   //sessionStorage.setItem('permissions', JSON.stringify(permissions));        
      // }
      sessionStorage.setItem('permissions', permissions); 
      sessionStorage.setItem('databaseId', databaseID);
      sessionStorage.setItem('organizationID', organizationID);
      sessionStorage.setItem('userToken', encryptedToken);
      sessionStorage.setItem('isRefresh', JSON.stringify(false));
    }
  }

  //Summary
  //returning decrypted user details.
  getLoggedInUserDetails(): Observable<any> {
    // return this.currentUser;
    return this.setCurrentUser.asObservable();
  }

  setFieldType(value, id){
    this.SubfolderModel.fieldType = value;
    this.SubfolderModel.subfolderId = id;
  }

  getFieldType(){
    return this.SubfolderModel;
  }

  setFieldData(values, fieldFolderType){
    this.fieldEditModel.fieldData = values;
    this.fieldEditModel.fieldFolderType = fieldFolderType;
  }

  getFieldData(){
    return this.fieldEditModel;
  }

  //Summary
  //clear localStorage and logout user.
  logoutUser() {
    // this.currentUser = {};
    // sessionStorage.removeItem("userToken");
    // sessionStorage.removeItem("permissions");
    // sessionStorage.removeItem("databaseId");
    // sessionStorage.removeItem("organizationID");
    // sessionStorage.removeItem("profileImagePath");
    // sessionStorage.removeItem("moduleName");
    // sessionStorage.removeItem("localFiltersContact");
    // sessionStorage.removeItem("localFiltersCompany");
    // sessionStorage.removeItem("localFilters");
    // sessionStorage.removeItem("folderAccess");
    // sessionStorage.removeItem("transactionID");
    // sessionStorage.removeItem("HeaderModuleName");
    // sessionStorage.removeItem("DashboardRefresh");
           
    //  this.router.navigate(['/auth/login']);
  }

  // To update User
  resetPassword(data: ResetPasswordReqVM): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.resetPassword;
    return this._http.post(apiURL, data);
  }

  // To update User
  forgotPasswordCheckUser(data): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.forgotPasswordCheckUser;
    return this._http.post(apiURL, data);
  }

  // To update User
  updatePassword(data): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updatePassword;
    return this._http.post(apiURL, data);
  }

   // To Change User Password
   changePassword(data): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.changePassword;
    return this._http.post(apiURL, data);
  }

  setEditData(data) {
    this.EditData = data;
  }

  getEditData() {
    return this.EditData;
  }

  refreshToken() {
    const encryptedtoken = sessionStorage.getItem('userToken');
    let refreshToken = sessionStorage.getItem('refreshToken');
    
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    if (refreshToken == null) {
      refreshToken = this.currentUser.RefreshToken
    }
    let reModel={
      userName: this.currentUser.UserName,
      name: this.currentUser.Name,
      uid: this.currentUser.UID,
      roles: this.currentUser.Roles,
      refreshToken: refreshToken,
    }
    const apiURL = this.constant.AuthPortNumber+'api/Auth/GetRefreshToken';
    return this._http.post(apiURL, reModel).pipe();
  }

}
